/**
 * Account → Graphical requests API. A header (title, base URL, language of
 * the documentation) and two tabs: the documentation and the account's API
 * keys / webhook. The section of the URL (api/graphical-requests/:section)
 * is a chapter of the documentation, or "keys" for the second tab.
 */
define('apiDocsPageView',[
  'module',
  'app',
  'marionette',
  'underscore',
  'jquery',
  'apiDocsContent',
  'apiDocsDocsView',
  'apiDocsKeysView',
  'entities/api_keys'
], function (Module, App, Marionette, _, $, Content, DocsView, KeysView) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({
    className: 'api-docs-page-view',

    template: _.template(
      '<header class="api-docs-header">' +
      '  <div class="api-docs-heading">' +
      '    <h1><i class="fa fa-code"></i> <%- ui.title %></h1>' +
      '    <p><%- ui.subtitle %></p>' +
      '  </div>' +
      '  <div class="api-docs-meta">' +
      '    <label class="api-docs-lang"><i class="fa fa-globe"></i>' +
      '      <select class="js-language" title="<%- ui.docLanguage %>">' +
      '        <% _.each(languages, function (l) { %>' +
      '        <option value="<%- l.code %>" <%= l.code === language ? "selected" : "" %>><%- l.label %></option>' +
      '        <% }); %>' +
      '      </select>' +
      '    </label>' +
      '    <div class="api-docs-base"><span><%- ui.baseUrl %></span><code class="js-base"><%- baseUrl %></code>' +
      '      <button type="button" class="api-doc-copy js-copy-base"><%- ui.copy %></button></div>' +
      '  </div>' +
      '</header>' +
      '<nav class="api-docs-tabs">' +
      '  <a href="#api/graphical-requests" class="js-tab <%= tab === "docs" ? "on" : "" %>" data-tab="docs">' +
      '    <i class="fa fa-book"></i> <%- ui.tabDocs %></a>' +
      '  <a href="#api/graphical-requests/keys" class="js-tab <%= tab === "keys" ? "on" : "" %>" data-tab="keys">' +
      '    <i class="fa fa-key"></i> <%- ui.tabKeys %></a>' +
      '</nav>' +
      '<div class="api-docs-body js-body"></div>'
    ),

    events: {
      'change .js-language': 'onLanguage',
      'click .js-copy-base': 'onCopyBase'
    },

    initialize: function (options) {
      this.section = options.section || null;
      this.language = Content.language();
      this.baseUrl = App.request('apiKeys:api-base-url');
    },

    serializeData: function () {
      return {
        ui: Content.get(this.language).ui,
        languages: Content.languages,
        language: this.language,
        baseUrl: this.baseUrl,
        tab: this.tab()
      };
    },

    tab: function () {
      return this.section === 'keys' ? 'keys' : 'docs';
    },

    onRender: function () {
      this.showBody();
    },

    /** Called by the router when only the section of the URL changed. */
    go: function (section) {
      var previousTab = this.tab();
      this.section = section || null;
      if (this.tab() !== previousTab) {
        this.render();
      } else if (this.body && this.body.scrollTo) {
        this.body.scrollTo(this.section);
      }
    },

    showBody: function () {
      if (this.body) {
        this.body.destroy();
      }
      var options = {content: Content.get(this.language), language: this.language, baseUrl: this.baseUrl};
      if (this.tab() === 'keys') {
        this.body = new KeysView(options);
      } else {
        this.body = new DocsView(_.extend(options, {section: this.section}));
      }
      this.$('.js-body').append(this.body.render().el);
      if (this.shown && this.body.onAttach) {
        this.body.onAttach();
      }
    },

    // First display: the body can only measure / scroll once the page is in the DOM.
    onShow: function () {
      this.shown = true;
      if (this.body && this.body.onAttach) {
        this.body.onAttach();
      }
    },

    onLanguage: function (e) {
      this.language = $(e.currentTarget).val();
      Content.setLanguage(this.language);
      this.render();
    },

    onCopyBase: function (e) {
      Content.copy(this.baseUrl, $(e.currentTarget), Content.get(this.language).ui);
    },

    onDestroy: function () {
      if (this.body) {
        this.body.destroy();
      }
    }
  });
});

